module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "CHAPTER 3"
    }
  }, [_c('header', [_c('p', {
    staticClass: "h2ch",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_c('span', {
    staticClass: "bg"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch3"
    }
  }, [_vm._v("CHAPTER 3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('b', [_vm._v("Y")])]), _c('b', [_vm._v("OU WANT TO")]), _vm._v(" come back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want to come back here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Be a policeman?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chief Superintendent Bernard Reade leaned back in his chair. He looked at Rossett’s written request, then back up at Rossett, who was standing directly in front of his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.” Rossett tried not to frown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wapping?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes . . . sir.” Rossett heard his nerves stretching in his reply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is nowhere else you’d rather go? A desk at Scotland Yard, maybe? Nice office, secretary, spot by a teapot?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want to come back here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("Reade tapped his index finger on his top lip, adjusted his position in his seat, and leaned forward so that his elbows were back on the desktop.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s just that, well—and please remember, this isn’t me saying this, Rossett, this is just me letting you know that . . . well . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“People might not want to work with me, sir?” Rossett filled in the blank.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reade nodded, opening his hands as he did so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not that you aren’t a good policeman. I’ve read your record.” Reade looked around his desk for the folder, gave up, and smiled at Rossett. “Plus there is all that medal-winning stuff in France, which was exceptional work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reade waited for Rossett to reply, but Rossett was staring out of the window at the Thames, watching a barge battle the wind, as he waited for whatever was going to come next.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Inspector?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett looked at Reade, who tried again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your exploits in France, they were exceptional.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reade chewed his lip and scratched behind his ear, then gestured that he wanted Rossett to say something.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett blinked, turned his head a quarter of an inch, sighed, and then spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was told I could apply to any station that I wished. I was told that my application would be a formality. I was told that I would be allocated a detective role commensurate with my rank.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("“This is where I started my career, this is where the challenge is, and this”—Rossett paused, fixing Reade with a stare—“is where I want to be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reade removed his spectacles and rubbed his eyes with his finger and thumb, then squinted up at Rossett, who had returned to staring out of the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve had no official confirmation of this, Rossett.” Reade sounded tired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One phone call can get you that, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t even know for certain if you’re still a policeman.” Reade offered up his hands to Rossett, then flopped them back down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve still got my warrant card.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you work for the Germans. I’ve checked. We don’t pay your wages; you don’t have an office, or a department, or men working under you.” Reade gestured to the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find me a job, sir.” Rossett looked at Reade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It isn’t that easy, Inspector.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can do anything. My record speaks for itself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s part of the problem, John.” Reade used Rossett’s first name for the first time. “Your record does speak, and what it says is, quite frankly, terrifying at times.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett raised an eyebrow as Reade wiped a hand across his mouth, regretting what he had said, aware that Rossett was still very much connected to his Germans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He tried again, conciliatory this time, leaning forward, letting his chair rock with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look.” He glanced at the request. “John, this is difficult for me to explain to you, but you’re well known here. From your time before the war and since you’ve been working for the Germans.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("“And?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And that has made some people reluctant to be associated with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t care.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I do, John. I have to look after you. I have to worry about your safety.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I look after myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can see that from your personnel file.” Reade cast an eye around the desk for the file again, then looked back at Rossett. “Look, I don’t know how else to say this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just say it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reade frowned, scratching his cheek as he took a deep breath. “If you return to policing, you will be in danger.” The words finally tumbled out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Every policeman is in danger; it’s the nature of the job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but you’ll be in danger from everyone, John. Criminals, resistance, and, even though I hate to say it, you’ll be in danger from fellow police officers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett went back to staring at the dirty black barge banging its prow against the incoming tide of the muddy brown Thames.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He knew how it felt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reade tried again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know how else to tell you, but you’re hated here. And not just here: you’re hated all over London.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve just been following orders.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It isn’t just about what you do with the Germans. Let’s be honest, John, you weren’t exactly popular before the war, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett looked at Reade, who gave a slight shake of his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t shoot the messenger; just try to understand the problem from my point of view.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("“I just want to be a policeman.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As that may be, I have to be careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I just carry on floating around?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reade leaned back in his chair again, his hands now holding the edge of his desk, as if he were expecting Rossett to snatch it away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go back to the Germans. They’ll have you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’d do well with them; you’ve done well with them. Promotions, nice easy job, maybe they’ll give you an apartment?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to be a policeman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett shifted his weight onto one leg and then, for the first time, wandered to the window. It was colder by the window, and across the south side of the Thames Rossett could see black snow falling from a gray cloud miles away. It looked like charcoal shading in a picture of the sky, and he squinted, trying to see it more clearly than the distance and dirty glass would allow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Half a minute passed until finally he spoke without turning around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To be good again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to try to make up for what I’ve done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve been doing your job; you’ve done nothing wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know what I’ve been doing,” Rossett replied, becoming aware that he could see himself inches away, reflected in the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He needed a shave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You said it yourself: you’ve been following orders. No one will criticize you for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("Rossett turned and faced Reade, who stared back at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know what I’ve been doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('b', [_vm._v("ROSSETT DIDN’T HAVE")]), _vm._v(" many friends left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In truth, although he tried not to think about it too much, he’d never had many friends to start with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As time had passed, and he had slipped further into the machinery that made up the Third Reich, his Christmas card list had gotten shorter and shorter, until finally there were only one or two names left on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not that he bothered sending cards anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of those names was walking toward him as he stood next to his Austin, finishing his cigarette, staring at the Thames, as the first snow of winter fell steadily outside the station.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d known Bill Fraser for over ten years. First they’d been young coppers together, walking the beat and dodging the sergeant on night shift. Then, after years of those shifts had passed by, they’d become the sergeants searching for lazy bobbies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were that rare thing, friends who could pick up where they left off. Years could pass and a conversation would continue as if one of them had paused for breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gi’s a fag, John?” Fraser flicked his fingers toward the cigarette Rossett was holding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett smiled, took out the packet, and passed it across the roof of his car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He waited for Fraser to light up, then caught the cigarettes when Fraser tossed them back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How you doin’? I heard you were in hospital?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t come and see me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("“German hospitals give me the creeps.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett nodded and gave a slightly thinner smile. “Stiff and sore, but getting there.” He took a drag on his cigarette, watching his friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You back on the job?” Fraser jerked a thumb toward the police station.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet.” Rossett noticed for the first time in their long relationship that the conversation seemed stilted, hanging awkwardly between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ain’t missing much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’d be surprised.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser leaned against the roof of the car and rolled the cigarette in his fingers, studying it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything all right, Fraze?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser tilted his head and then gave a tiny shake; he frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, mate, I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wanted to say . . . well, I heard you was looking to come back ’ere.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser shrugged and shoved his hands in his pockets against the cold. Here and there patches of gray cobbles poked through the snow, like mountaintops through thick cloud.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not like in the old days, mate.” Fraser’s cigarette bobbed as he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I keep hearing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser shifted his feet in the snow, scratching away until he could see a cobble under his boot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The whole place has changed, John, it isn’t like it was. The crooks are crookeder, most of the bobbies are worse, even the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("magistrates ain’t averse to a little touch or two, if you know what I mean.” Fraser winked.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about the sergeants, Fraze?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser looked behind him and then joined Rossett on his side of the car, leaning in close enough that their shoulders touched. He took the cigarette out of his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Things are tough round here, John. We’ve got resistance and smugglers, on top of the usual thieves and vagabonds we knew back in our day. Christ almighty, most of them are the same people who’ve stepped up a gear.” Fraser looked over his shoulder at the station and then continued. “When you worked here it was a picnic. Nowadays you don’t know who you’re talking to. You’ve got to be careful; there is a lot of money to be made, inside the law or outside the law. It isn’t just money, either: one wrong word, a dirty look, or a rumor spread can have you up in front of the Gestapo, and I don’t need to tell you about them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you do your job the right way, you’ve nothing to worry about. It’s very simple,” Rossett said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser chuckled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Simple for you, maybe. Not so simple for the blokes who want to go home to their families at the end of their shift.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett looked at Fraser, who immediately regretted his words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry. I didn’t mean . . . your family. I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett stared at the river, putting his cigarette into the corner of his mouth. The cigarette glowed orange, the only color for what seemed like miles around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett breathed out the smoke through his nose as Fraser tried again to explain his position.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All I’m telling you is it can be dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett nodded, then looked at Fraser again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("“Are you a bent copper?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser opened his mouth as he took half a step away from Rossett, their shoulders no longer touching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you a bent copper?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re asking me that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t believe you’d ask me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t believe I’d ask you because we’re mates? Or because nobody asks that question?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because we’re mates.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry.” Rossett finally blinked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser nodded, then followed Rossett’s gaze across the river.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This place is all changed. Time was, if we knew who was up to no good we would just go and lift ’em. Now, well . . . we know who runs the manor and we can’t touch ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know who runs the manor—who is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser took the cigarette out of his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, mate. Seriously, no . . . I want to go home of a night, and you want to be careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett thought about the answer as he lowered his head and flicked away his cigarette into the snow to smolder and die.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve got to learn, John, things have changed around here. Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought I understood.” Rossett pushed himself off the car and turned to face Wapping Police Station with its bare brown brick, topped off with a limp Union Jack, hanging next to an even limper bloodred swastika flag. “I’m not so sure now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("“You take care, John, you hear me? Take care about what questions you ask and where you ask them. It’s dangerous, even for someone like you.” Fraser tapped a finger on the roof of Rossett’s car and turned to head back into the station. Rossett looked up at the heavy gray sky and the dots of snow that were falling faster from it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked back at the station where he had learned to be a policeman all those years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seemed the same on the outside, all except for the swastika.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett fingered his own swastika lapel badge and then looked down at it. He and the station had a lot more in common than he cared to admit. He watched as Fraser jogged up the steps and pushed against the heavy entrance door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fraze!” Rossett shouted. Fraser stopped and turned, half in, half out of the building, one hand holding the door open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just want to be a policeman again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fraser stared at Rossett, then let the door swing shut behind him, leaving Rossett alone in the snow.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-354bb3d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062394613_Chapter_3.vue
// module id = 78
// module chunks = 0